import { useCan } from "components";
import { useSelectedLocation } from "components/DealersAndLocationsDropdown/hooks";
import { useTypedQuery } from "hooks/useTypedQuery";
import { ACL_ACTIVITIES, ACL_RESOURCES } from "models";
import { NoteSuggestionsQueryKeys } from "modules/NoteSuggestions/queryKeys";
import { ApiInstance } from "utils/Api";

// TODO: remove this, the locations we load already contains the note suggestions and types
export const useLocationWithSuggestionsQuery = () => {
  const { selectedLocation } = useSelectedLocation();
  const canListLocations = useCan(ACL_ACTIVITIES.List, ACL_RESOURCES.Locations);

  const { data: location, isLoading } = useTypedQuery({
    queryKey: NoteSuggestionsQueryKeys.location,
    queryFn: async ({ endpoint, baseUrl }) => (await ApiInstance.post(endpoint, { id: selectedLocation?.id }, baseUrl)).data,
    enabled: Boolean(selectedLocation?.id) && canListLocations
  });

  return { location, isLoading };
};
